import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LojistiklerPage } from 'src/model/lojistikler-page';
import { Page } from 'src/model/page';
import { HelperProvider } from 'src/providers/helper.provider';
import { RestService } from 'src/providers/rest.service';

@Component({
  selector: 'app-lojistik',
  templateUrl: './lojistik.component.html',
  styleUrls: ['./lojistik.component.css']
})
export class LojistikComponent implements OnInit {

  showSearchResultCount = 10;
  showSearchResultCountModel: number[] = [10, 20, 50, 100];
  aramaLoading = false;
  aramaText = '';
  source: LojistiklerPage = null;
  showSearchCurrentPage = 1;
  private subscriptions: Subscription[] = [];

  constructor(private helperProvider: HelperProvider,
    private router: Router,
    private restService: RestService) { }

  ngOnInit() {
    this.helperProvider.currentPage$.next(Page.Lojistikler);

    this.subscriptions.push(this.helperProvider.changedSelectedBranches$.subscribe(res => {
      if (res != null) {
        this.getLojistikler();
      }
    }));

    this.getLojistikler();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getLojistikler() {
    this.restService.getLojistikler(this.showSearchCurrentPage, this.showSearchResultCount, null, this.aramaText)
      .subscribe(res => {
        this.source = res;
      });
  }

  showPreviousPageSearchResults() {
    this.showSearchCurrentPage--;
    this.getLojistikler();
  }

  showNextPageSearchResults() {
    this.showSearchCurrentPage++;
    this.getLojistikler();
  }

  aramaInputChange() {
    this.showSearchCurrentPage = 1;
    this.getLojistikler();
  }

  new() {
    this.router.navigate(['rota-olustur'], { queryParams: { id: '0' } });
  }
}
